/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_CreatedInputs */

const zh_course_created = /** @type {(inputs: Course_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程已创建`)
};

const en_course_created = /** @type {(inputs: Course_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course created`)
};

const es_course_created = /** @type {(inputs: Course_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curso creado`)
};

/**
* | output |
* | --- |
* | "Course created" |
*
* @param {Course_CreatedInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const course_created = /** @type {((inputs?: Course_CreatedInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_CreatedInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_created(inputs)
	if (locale === "en") return en_course_created(inputs)
	return es_course_created(inputs)
});